import { render, staticRenderFns } from "./CarServicer.vue?vue&type=template&id=66e8827a"
import script from "./CarServicer.vue?vue&type=script&setup=true&lang=js"
export * from "./CarServicer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports